import { useEffect, useState } from "react";
import { HeartHandshake, Landmark } from "lucide-react";
import { api } from "@/lib/api";
import { rupiah, tanggal } from "@/lib/format";
import { PublicPage } from "@/components/landing/PublicPage";
import { DonationSection } from "@/components/landing/DonationSection";

const TYPES = { infaq: "Infaq", sedekah: "Sedekah", zakat: "Zakat", pembangunan: "Dana Pembangunan" };

export default function Donasi() {
  const [settings, setSettings] = useState(null);
  const [donors, setDonors] = useState([]);
  useEffect(() => {
    api.get("/donations/public-settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/donations/confirmed?limit=100").then((r) => setDonors(r.data)).catch(() => {});
  }, []);

  return (
    <PublicPage testId="donasi-page" eyebrow="Donasi Online" title="Salurkan Infaq & Sedekah Anda" desc="Pilih jenis donasi, transfer ke rekening atau scan QRIS, lalu unggah bukti agar pengurus dapat mengonfirmasi. Nama Anda akan tampil di daftar donatur sebagai bentuk transparansi.">
      <div className="space-y-16">
        <DonationSection settings={settings} full />
        {settings?.bank_account && (
          <div className="rounded-3xl bg-white border border-emerald-900/10 p-6 sm:p-8 grid sm:grid-cols-3 gap-6" data-testid="donasi-rekening-info">
            <div className="flex items-center gap-3 sm:col-span-1">
              <div className="h-11 w-11 rounded-2xl emerald-bg text-[#d4af37] flex items-center justify-center"><Landmark size={20} /></div>
              <div><p className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">Informasi Rekening</p><p className="font-bold text-emerald-950">Rekening Resmi Masjid</p></div>
            </div>
            <div className="sm:col-span-2 grid sm:grid-cols-3 gap-4 text-sm">
              <div><p className="text-slate-500">Bank</p><p className="font-semibold text-emerald-950">{settings.bank_name}</p></div>
              <div><p className="text-slate-500">No. Rekening</p><p className="font-mono font-bold text-emerald-950 text-lg">{settings.bank_account}</p></div>
              <div><p className="text-slate-500">Atas Nama</p><p className="font-semibold text-emerald-950">{settings.bank_holder}</p></div>
            </div>
          </div>
        )}
        <section data-testid="donasi-riwayat">
          <div className="flex items-center gap-3">
            <HeartHandshake className="text-emerald-800" />
            <h2 className="text-xl sm:text-2xl font-bold text-emerald-950">Donasi Terkonfirmasi</h2>
            <span className="text-sm text-slate-500 ml-auto" data-testid="donasi-riwayat-count">{donors.length} donasi</span>
          </div>
          <div className="mt-5 rounded-3xl bg-white border border-emerald-900/10 overflow-hidden">
            {donors.length === 0 ? (
              <p className="p-8 text-center text-sm text-slate-500" data-testid="donasi-riwayat-empty">Belum ada donasi terkonfirmasi.</p>
            ) : (
              <table className="w-full text-sm">
                <thead className="bg-emerald-50 text-emerald-900 text-left"><tr><th className="px-5 py-3">Tanggal</th><th className="px-5 py-3">Donatur</th><th className="px-5 py-3">Jenis</th><th className="px-5 py-3 text-right">Nominal</th></tr></thead>
                <tbody>
                  {donors.map((d) => (
                    <tr key={d.id} className="border-t border-emerald-900/5" data-testid={`donasi-riwayat-row-${d.id}`}>
                      <td className="px-5 py-3 text-slate-600">{tanggal(d.date || d.confirmed_at?.slice(0, 10))}</td>
                      <td className="px-5 py-3 font-medium text-emerald-950">{d.name}</td>
                      <td className="px-5 py-3">{TYPES[d.type] || d.type}</td>
                      <td className="px-5 py-3 text-right font-semibold text-emerald-950">{rupiah(d.amount)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </section>
      </div>
    </PublicPage>
  );
}
